module.exports = __webpack_public_path__ + "img/not-found-vk.4a3e9c6d.svg";